export enum ComponentType
{
    App,
    Select,
    Input,
    CalculateResult
}